import React from 'react'
import './styles.css'
import { TbRotateClockwise } from 'react-icons/tb'
import { AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai'

interface PlanActionsProps {
  onRestart: () => void
  onCreate: () => void
  onEdit: () => void
  onDelete: () => void
  disabled?: boolean
  isDarkMode?: boolean
}

const PlanActions: React.FC<PlanActionsProps> = ({
  onRestart,
  onCreate,
  onEdit,
  onDelete,
  disabled,
  isDarkMode,
}) => {
  return (
    <div
      className={`plan-actions ${isDarkMode ? 'dark' : 'light'}`}
      data-tour="dashboard-plan-actions"
    >
      {/* <button
        className="plan-action-button restart"
        onClick={onRestart}
        disabled={disabled}
        title="Reiniciar ciclo"
      >
        <TbRotateClockwise size={18} />
        REINICIAR
      </button> */}
      <button
        className="plan-action-button create"
        onClick={onCreate}
        disabled={disabled}
        title="Criar novo plano"
      >
        <AiOutlinePlus size={18} />
        Criar novo plano
      </button>
      <button
        className="plan-action-button edit"
        onClick={onEdit}
        disabled={disabled}
        title="Editar plano"
      >
        <AiOutlineEdit size={18} />
        Editar
      </button>
      {/* <button
        className="plan-action-button delete"
        onClick={onDelete}
        disabled={disabled}
        title="Excluir plano"
      >
        <AiOutlineDelete size={18} />
        Excluir plano
      </button> */}
    </div>
  )
}

export default PlanActions
